import {MNullable} from '../../Toolkit/Utils';
import {Crew, CrewContact} from './CrewTypes';

export class CrewContactData {
    public crew: Crew = new Crew();
    public crewContacts: CrewContact[] = [];
};

export class WorkMailReply {
    public crew: MNullable<CrewContactData> = null;
};

export class WorkMailMultiReply {
    public crews: CrewContactData[] = [];
};